// eslint-disable-next-line no-unused-vars
import {reactive} from "vue";

function formatTimeDifference(lastMessageTime) {
    const now = new Date();
    if (lastMessageTime == null) {
        return "Нет данных";
    }
    const lastMessageDate = new Date(lastMessageTime);

    let delta = Math.abs(now - lastMessageDate) / 1000;  // разница в секундах

    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    const seconds = Math.floor(delta % 60);

    let result = "";
    if (days > 0) {
        result += ` ${days}д `;
    }
    if (hours > 0) {
        result += ` ${hours}ч `;
    }
    if (minutes > 0) {
        result += ` ${minutes} мин `;
    }
    if (seconds > 0 && result === "") {
        result += ` ${seconds} сек`;
    }

    return result.trim();
}

async function getAddress(lat, lon) {
    if (lat == null || lon == null) {
        return "Нет данных";
    }
    const url = new URL('https://nominatim.openstreetmap.org/reverse');
    url.search = new URLSearchParams({
        format: 'json',
        lat: lat,
        lon: lon
    });

    try {
        const response = await fetch(url);
        if (!response.ok) {
            console.error('Error');

        }
        const data = await response.json();
        return data.display_name;
    } catch (error) {
        console.error('Error fetching address:', error);
        return null;
    }
}

function getColorBasedOnTimeDifference(lastMessageTime) {
    const now = new Date();
    if (!lastMessageTime) {
        return reactive({background: "gray"});
    }
    const lastMessageDate = new Date(lastMessageTime);

    let delta = Math.abs(now - lastMessageDate) / 1000;  // разница в секундах

    const deltaHours = Math.floor(delta / 3600);

    if (deltaHours < 1) {
        return reactive({background: "green"});
    } else if (deltaHours < 3) {
        return reactive({background: "#fad23c"});
    } else {
        return reactive({background: "#FF7C7C"});
    }
}

function getTextBasedOnTimeDifference(lastMessageTime) {
    const now = new Date();
    if (!lastMessageTime) {
        return 'Нет\u00A0данных';
    }
    const lastMessageDate = new Date(lastMessageTime);

    let delta = Math.abs(now - lastMessageDate) / 1000;  // разница в секундах

    const deltaHours = Math.floor(delta / 3600);

    if (deltaHours < 1) {
        return 'Хороший\u00A0сигнал';
    } else if (deltaHours < 3) {
        return 'Средний\u00A0сигнал';
    } else {
        return 'Слабый\u00A0сигнал';
    }
}

export {formatTimeDifference, getAddress, getColorBasedOnTimeDifference, getTextBasedOnTimeDifference} ;